import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGithub = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9 0.222656C4.02981 0.222656 0 4.25246 0 9.22266C0 13.1988 2.57824 16.5729 6.15499 17.7621C6.60507 17.8456 6.77049 17.5669 6.77049 17.3285C6.77049 17.1139 6.76155 16.4045 6.75857 15.6534C4.25335 16.1973 3.72578 14.5923 3.72578 14.5923C3.31595 13.552 2.72727 13.2748 2.72727 13.2748C1.91058 12.716 2.78838 12.7279 2.78838 12.7279C3.69151 12.792 4.16841 13.6548 4.16841 13.6548C4.97168 15.0304 6.27422 14.6325 6.78689 14.403C6.86736 13.8218 7.10134 13.4238 7.35767 13.1988C5.35917 12.9708 3.25782 12.1988 3.25782 8.75172C3.25782 7.7696 3.60954 6.96632 4.1848 6.33592C4.09091 6.10939 3.7839 5.19434 4.27124 3.9544C4.27124 3.9544 5.02683 3.71297 6.74665 4.8769C7.46498 4.6772 8.23398 4.57735 9 4.57437C9.76453 4.57735 10.535 4.6772 11.2548 4.8769C12.9732 3.71297 13.7273 3.9544 13.7273 3.9544C14.2176 5.19434 13.9091 6.10939 13.8152 6.33592C14.392 6.96632 14.7407 7.7696 14.7407 8.75172C14.7407 12.2078 12.6349 12.9693 10.6319 13.1928C10.9553 13.4715 11.2429 14.02 11.2429 14.859C11.2429 16.0632 11.2325 17.0319 11.2325 17.3285C11.2325 17.5684 11.3949 17.8486 11.851 17.7607C15.4247 16.5699 18 13.1973 18 9.22266C18 4.25246 13.9702 0.222656 9 0.222656Z",
				fill: "currentColor",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.40792 13.1437C3.38854 13.1884 3.31701 13.2018 3.25293 13.1705C3.18735 13.1407 3.15158 13.0796 3.17245 13.0349C3.19182 12.9887 3.26187 12.9768 3.32744 13.0066C3.39301 13.0379 3.43027 13.099 3.40792 13.1437Z",
				fill: "currentColor",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.77317 13.5498C3.72995 13.5901 3.64649 13.5707 3.58986 13.5081C3.53025 13.4455 3.51981 13.3621 3.56303 13.3218C3.60774 13.2816 3.68822 13.301 3.74783 13.3636C3.80595 13.4262 3.81788 13.5096 3.77317 13.5498Z",
				fill: "currentColor",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.12811 14.0688C4.07296 14.1076 3.98206 14.0718 3.92691 13.9913C3.87177 13.9108 3.87177 13.8155 3.9284 13.7767C3.98355 13.738 4.07296 13.7722 4.1296 13.8527C4.18474 13.9332 4.18474 14.0301 4.12811 14.0688Z",
				fill: "currentColor",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.61377 14.57C4.56459 14.6252 4.45878 14.6102 4.38277 14.5357C4.30379 14.4627 4.28292 14.3599 4.3321 14.3062C4.38277 14.2511 4.4871 14.2675 4.56459 14.3405C4.64209 14.412 4.66593 14.5164 4.61377 14.57Z",
				fill: "currentColor",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.28459 14.8607C5.26223 14.9308 5.16089 14.9636 5.05955 14.9337C4.95821 14.9025 4.89115 14.8205 4.91201 14.7489C4.93288 14.6774 5.03422 14.6446 5.13705 14.6759C5.23988 14.7072 5.30545 14.7892 5.28459 14.8607Z",
				fill: "currentColor",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.02076 14.9144C6.02374 14.9889 5.9373 15.05 5.83 15.0515C5.72269 15.0545 5.63477 14.9934 5.63477 14.9203C5.63477 14.8458 5.71971 14.7847 5.82702 14.7832C5.93283 14.7817 6.02076 14.8414 6.02076 14.9144Z",
				fill: "currentColor",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.70584 14.7982C6.71925 14.8712 6.64473 14.9442 6.53743 14.9651C6.43311 14.9845 6.33624 14.9398 6.32282 14.8682C6.30941 14.7937 6.38542 14.7192 6.48974 14.6998C6.59704 14.6805 6.69242 14.7252 6.70584 14.7982Z",
				fill: "currentColor",
				fillOpacity: .8
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 17.5544,
			fill: "white",
			transform: "translate(0 0.222656)"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgGithub);
export { ForwardRef as ReactComponent };
